/**
 * Shared alert-strip dismiss + session-persistence.
 * Markup: <div class="md-alert-strip" data-md-alert-strip="{id}"
 *              data-md-persistence="view|session">…
 *           <button class="md-alert-strip-dismiss">×</button>
 *         </div>
 * 'view'    : remove from DOM only.
 * 'session' : remove from DOM AND remember in sessionStorage.
 */
(function () {
    var STORAGE_PREFIX = 'md_alert_strip:';

    function safeGet(key) {
        try {
            return window.sessionStorage.getItem(key);
        } catch (e) {
            return null;
        }
    }

    function safeSet(key, val) {
        try {
            window.sessionStorage.setItem(key, val);
        } catch (e) {}
    }

    function hidePersistedStrips() {
        var nodes = document.querySelectorAll('[data-md-alert-strip]');
        for (var i = 0; i < nodes.length; i++) {
            var el = nodes[i];
            if (el.getAttribute('data-md-persistence') !== 'session') {
                continue;
            }
            var id = el.getAttribute('data-md-alert-strip') || '';
            if (id && safeGet(STORAGE_PREFIX + id)) {
                el.remove();
            }
        }
    }

    function onDismissClick(e) {
        var btn = e.target && e.target.closest ? e.target.closest('.md-alert-strip-dismiss') : null;
        if (!btn) {
            return;
        }
        var strip = btn.closest('[data-md-alert-strip]');
        if (!strip) {
            return;
        }
        var id = strip.getAttribute('data-md-alert-strip') || '';
        var mode = strip.getAttribute('data-md-persistence') === 'session' ? 'session' : 'view';
        if (mode === 'session' && id) {
            safeSet(STORAGE_PREFIX + id, '1');
        }
        strip.remove();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', hidePersistedStrips);
    } else {
        hidePersistedStrips();
    }
    document.addEventListener('click', onDismissClick);
})();
